<template>
  <MainWrapper v-if="$store.state.authenticated">
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h3 class="mb-30">Мой профиль</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="white-panel pt-20 pb-20 pr-20 pl-20">
              <div class="container-fluid">
                <div class="row">
                  <div class="tabs mb-30">
                    <router-link :to="'/user/settings'" class="tab pb-7 mr-30 inline-block">
                      <h4 @click="tab = 'main'">Персональные данные</h4>
                    </router-link>
                    <router-link
                      :to="'/user/settings#mobile'"
                      class="tab pt-4 pb-15 mr-30 inline-block"
                    >
                      <h4 @click="tab = 'mobile'">Сменить номер телефона</h4>
                    </router-link>
                    <!--
                                    <router-link :to="'/user/settings#email'" class="tab pb-15 mr-30 inline-block">
                                        <h4 @click="tab = 'email'">Сменить email адрес</h4>
                                    </router-link>
                    -->
                    <div class="light-gray-line"></div>
                  </div>
                </div>
                <div v-if="tab === 'email'" class="row">
                  <div class="col-lg-6 no-p">
                    <p class="dark-body-text mb-10">Смена email адреса</p>
                    <p
                      class="mb-15"
                    >Для того, чтобы сменить текущий email адрес введите его в поле находящееся ниже и введите код подтверждения</p>
                    <div class="input-wrapper mb-10">
                      <input
                        class="rounded-input mr-15"
                        type="text"
                        v-model="email"
                        placeholder="example@example.com"
                        style="background:#f2f2f2"
                        disabled
                      />
                    </div>
                    <div class="button-wrapper mt-30 mb-30">
                      <Button type="blue" text="Обновить" />
                    </div>
                  </div>
                </div>
                <div v-if="tab === 'mobile'" class="row">
                  <div class="col-lg-6 no-p">
                    <p class="dark-body-text mb-10">Смена номера телефона</p>
                    <p
                      class="mb-15"
                    >Для того, чтобы сменить текущий номер телефона введите его в поле находящееся ниже и введите код подтверждения</p>
                    <div class="input-wrapper mb-10">
                      <!--<masked-input v-model="phone" mask="\9\9\6 111 11 11 11" placeholder-char=" " placeholder="Введите телефон" type="tel" class="rounded-input mr-15" style="background:#f2f2f2" disabled />-->
                      <input
                        class="rounded-input mr-15"
                        type="tel"
                        v-model="phone"
                        placeholder="996556088891"
                        style="background:#f2f2f2"
                        disabled
                      />
                    </div>
                    <div class="button-wrapper mt-30 mb-30">
                      <Button type="blue" text="Обновить" />
                    </div>
                  </div>
                </div>
                <div v-if="tab === 'main'" class="row">
                  <div class="col-lg-6 no-p">
                    <p class="dark-body-text mb-10">Ваши личные данные</p>
                    <p
                      class="mb-15"
                    >Заполните все поля. Это необходимое условие для записи к специалистам и обеспечению безопасности вашей учетной записи.</p>
                    <div class="input-wrapper mb-10">
                      <input
                        v-model="full_name"
                        class="rounded-input"
                        type="text"
                        placeholder="Иванов Иван"
                      />
                    </div>
                    <!--
                                    <div class="input-wrapper mb-10">
                                        <input v-model="birth_date" class="rounded-input" type="date" placeholder="" />
                                    </div>
                                    <div class="input-wrapper mb-10">
                                        <select v-model="sex" class="rounded-input">
                                            <option value="">Выберите</option>
                                            <option v-if="sex == 'Мужской'" value="Мужской" selected>Мужской</option>
                                            <option v-else value="Мужской">Мужской</option>
                                            <option v-if="sex == 'Женский'" value="Женский" selected>Женский</option>
                                            <option v-else value="Женский">Женский</option>
                                        </select>
                                    </div>
                    -->
                    <div class="button-wrapper mt-30 mb-30">
                      <Button @click="setUserInfo" type="blue" text="Сохранить данные" />
                    </div>
                    <p class="dark-body-text mb-10">Смена пароля</p>
                    <p class="mb-15">Для того, чтобы сменить пароль вам нужно ввести текущий пароль.</p>
                    <div class="input-wrapper mb-10">
                      <input
                        v-model="old_password"
                        class="rounded-input"
                        type="password"
                        placeholder="Введите ваш пароль"
                      />
                    </div>
                    <div class="input-wrapper mb-10">
                      <input
                        v-model="new_password"
                        class="rounded-input"
                        type="password"
                        placeholder="Введите новый пароль"
                      />
                    </div>
                    <div class="input-wrapper mb-30">
                      <input
                        v-model="new_password_confirm"
                        class="rounded-input"
                        type="password"
                        placeholder="Повторите новый пароль"
                      />
                    </div>
                    <div class="button-wrapper mb-30">
                      <Button @click="setPassword" type="blue" text="Изменить пароль" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
  <NotFound v-else />
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.icon {
  font-size: 18px;
}

.single-filter {
  display: inline-flex;
  align-items: center;

  .filter-icon {
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 1px solid cyan_dark_color;
    color: cyan_dark_color;
  }
}

.pull-right {
  margin-left: auto;
}
</style>
<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import News from "@/components/News.vue";
import Paginator from "@/components/Paginator.vue";
import http from "@/methods/http.ts";
import NotFound from "@/views/NotFound.vue";
import MaskedInput from "vue-masked-input";

@Component({
  components: {
    MainWrapper,
    Button,
    News,
    Paginator,
    NotFound,
    MaskedInput,
  },
})
export default class MainSettings extends Vue {
  tab = "main";
  full_name = "";
  email = "";
  phone = "";
  birth_date = "";
  sex = "";
  old_password = "";
  new_password = "";
  new_password_confirm = "";

  getUserInfo() {
    http("user/info", "get", this.$store.state.token, {}).then((r) => {
      this.full_name = r.data.full_name;
      this.email = r.data.email;
      this.phone = r.data.phone;
      this.sex = r.data.sex;
      if (r.data.birth_date) {
        let birth_date = r.data.birth_date;
        birth_date = birth_date.split(".");
        this.birth_date =
          birth_date[2] + "-" + birth_date[1] + "-" + birth_date[0];
      }
    });
  }

  setUserInfo() {
    /*
            if (this.full_name === '') {
                this.$store.commit('notificate', { text: 'Введите ваши ФИО', type: 'error' });
                return false;
            }
            */
    http("user/update", "put", this.$store.state.token, {
      full_name: this.full_name,
      sex: this.sex,
      birth_date: this.birth_date,
    })
      .then((r) => {
        this.getUserInfo();
        this.$store.commit("notificate", {
          text: r.data.message,
          type: "action",
        });
      })
      .catch((error) => {
        this.$store.commit("notificate", {
          text: error.response.data.message,
          type: "error",
        });
      });
  }

  setPassword() {
    if (this.old_password === "") {
      this.$store.commit("notificate", {
        text: "Введите ваш пароль",
        type: "error",
      });
      return false;
    }
    if (this.new_password === "") {
      this.$store.commit("notificate", {
        text: "Введите новый пароль",
        type: "error",
      });
      return false;
    }
    if (this.new_password !== this.new_password_confirm) {
      this.$store.commit("notificate", {
        text: "Повторите новый пароль",
        type: "error",
      });
      return false;
    }
    http("user/change/password", "post", false, {
      token: this.$store.state.token,
      old_password: this.old_password,
      new_password: this.new_password,
    })
      .then((r) => {
        this.old_password = "";
        this.new_password = "";
        this.new_password_confirm = "";
        this.$store.commit("notificate", {
          text: r.data.message,
          type: "action",
        });
      })
      .catch((error) => {
        this.$store.commit("notificate", {
          text: error.response.data.message,
          type: "error",
        });
      });
  }

  created() {
    let hash = this.$router.history.current.hash;
    hash = hash.replace("#", "");
    if (hash !== "") {
      this.tab = hash;
    }
    this.getUserInfo();
  }
}
</script>